/*  反馈接口  */
const _import = require("../_import");

export default [
  {
    path: "/myquiz",
    name: "MyQuiz",
    meta: { title: "我的问题", from: 1 },
    component: _import("myquiz")
  },
  {
    path: "/announcement",
    name: "Announcement",
    meta: { title: "公告", from: 1 },
    component: _import("announcement")
  },
  {
    path: "/noticedetail",
    name: "NoticeDetail",
    meta: { title: "公告详情", from: 1 },
    component: _import("announcement/noticeDetail")
  },
  {
    path: "/quizdetail",
    name: "QuizDetail",
    meta: { title: "我的问题详情", from: 1 },
    component: _import("myquiz/quizDetail")
  },
  {
    path: "/quikform",
    name: "QuikForm",
    meta: { title: "快速表单", from: 1 },
    component: _import("quickform")
  },
  // 选择游戏区服界面
  {
    path: "/gamechoose",
    name: "GameChoose",
    meta: { title: "选择区服", from: 1 },
    component: _import("quickform/gameChoose")
  },
  {
    path: "/formlist",
    name: "FormList",
    meta: { title: "我的问题", from: 1 },
    component: _import("formlist")
  },
  {
    path: "/nofkeycontent",
    name: "NoFkeyContent",
    meta: { title: "无表单公告", from: 1 },
    component: _import("quickform/noFkeyContent")
  },
  {
    path: "/faq",
    name: "Faq",
    meta: { title: "自助服务", from: 1 },
    component: _import("faq")
  },
  {
    path: "/hotquiz",
    name: "HotQuiz",
    meta: { title: "热门问题", from: 1 },
    component: _import("hotquiz")
  },
  {
    path: "/vip",
    name: "Vip",
    meta: { title: "贵宾服务", from: 1 },
    component: _import("vip")
  },
];
